"use strict";

define('uikit/modules/sidebar',['marionette', '../mixins/component.mixin', './menu', '../channel'], function (Mn, ComponentMixin, Menu, channel) {
  var Sidebar = Menu.extend({
    className: 'ui sidebar',
    options: _.extend({}, Menu.prototype.options, {
      menu: false,
      push: true,
      size: ''
    }),
    updateAttributes: function updateAttributes() {
      Menu.prototype.updateAttributes.apply(this, arguments);
      this.addClass(this.getSizeClass(), this.getBoolOption('size'));
      this.addClass('menu', this.getBoolOption('menu'));
      this.addClass('push', this.getBoolOption('push'));
      this.addClass('visible', this.getBoolOption('visible'));
    },
    getSizeClass: function getSizeClass() {
      switch (this.size) {
        case 'thin':
        case 'very thin':
        case 'wide':
        case 'very wide':
          return this.size;
        default:
          return '';
      }
    }
  });
  channel.reply('sidebar', function () {
    return Sidebar;
  });
  return Sidebar;
});

